import type { FaireProductEntity } from "../../entity_types/product";

export const p_a2aqje85yt: FaireProductEntity = {
  token: "p_a2aqje85yt",
  type: "product",
  name: "10 Piece Opal Ring Set with Crystals 18K Gold Plated",
  brandToken: "b_3u7f7kz1",
  brandName: "Golden NYC Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/6cb1d5e2e8caa48e233708726e7c964e12f72452c8d566e4555c2e91fa0e0dab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a310f6a692b2c8cc9e16e7770befb68534e43d20f60a6569f0cec48ea5c62658.jpeg",
    "https://cdn.faire.com/fastly/27c54d1a2f6897d95b8188ac552185b9745dcd94995cd1bdbf2846da3bea67a2.jpeg",
    "https://cdn.faire.com/fastly/3fd5c14c07071ca813353f028e071f516721154ef98d8d2720319a694c9009b7.jpeg",
    "https://cdn.faire.com/fastly/128eceb1e4337b9bd41743f0de0f5f70b6e25281b5de3c540cfd86ee6b273a42.jpeg",
    "https://cdn.faire.com/fastly/d982358b683b5340cfd2c5e830c8eb4651f962dc6ccc430dba1cf5c5eb4a7955.jpeg",
    "https://cdn.faire.com/fastly/c1e324f6644caae569b302c7106fe496ede547b4bbc341ff6813badb223a8934.jpeg",
    "https://cdn.faire.com/fastly/6add913fdcf3bfa402ae1d76d3ac24469897fce96693b4b3c087e865b3e5c2d5.jpeg",
  ],
  priceDollars: 6.93,
  description: 'Dimensions:0.15"\nHypoallergenic Jewelry\nComfort Fit Jewelry',
  tags: [],
  msrpDollars: 41.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:29.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
